export const FETCH_BETA_REQUEST = 'FETCH_BETA_REQUEST';
export const FETCH_BETA_SUCCESS = 'FETCH_BETA_SUCCESS';
export const FETCH_BETA_FAILURE = 'FETCH_BETA_FAILURE';

export const UPLOAD_BETA_EMAIL_REQUEST = 'UPLOAD_BETA_EMAIL_REQUEST';
export const UPLOAD_BETA_EMAIL_SUCCESS = 'UPLOAD_BETA_EMAIL_SUCCESS';
export const UPLOAD_BETA_EMAIL_FAILURE = 'UPLOAD_BETA_EMAIL_FAILURE';

export const SEARCH_BETA_EMAIL_REQUEST_REQUEST = 'SEARCH_BETA_EMAIL_REQUEST_REQUEST';
export const SEARCH_BETA_EMAIL_REQUEST_SUCCESS = 'SEARCH_BETA_EMAIL_REQUEST_SUCCESS';
export const SEARCH_BETA_EMAIL_REQUEST_FAILURE = 'SEARCH_BETA_EMAIL_REQUEST_FAILURE';

export const fetchBetaTimeRequest = (page, limit) => ({
  type: FETCH_BETA_REQUEST,
  payload: { page, limit },
});

export const fetchBetaTimeSuccess = (betaEmail) => ({
  type: FETCH_BETA_SUCCESS,
  payload: betaEmail,
});

export const fetchBetaTimeFailure = (error) => ({
  type: FETCH_BETA_FAILURE,
  payload: error,
});

export const uploadBetaEmailRequest = (email) => ({
  type: UPLOAD_BETA_EMAIL_REQUEST,
  payload: email,
});

export const uploadBetaEmailSuccess = () => ({
  type: UPLOAD_BETA_EMAIL_SUCCESS,
});

export const uploadBetaEmailFailure = (error) => ({
  type: UPLOAD_BETA_EMAIL_FAILURE,
  payload: error,
});

export const searchiOSBetaRequest = (searchTerm) => ({
  type: SEARCH_BETA_EMAIL_REQUEST_REQUEST,
  payload: { searchTerm },
});

export const searchiOSBetaSuccess = (betaEmail) => ({
  type: SEARCH_BETA_EMAIL_REQUEST_SUCCESS,
  payload: betaEmail,
});

export const searchiOSBetaFailure = (error) => ({
  type: SEARCH_BETA_EMAIL_REQUEST_FAILURE,
  payload: error,
});



